import {
	space,
	markDiscovered,
	editPageMetadata,
} from '@confluence-classic/confluence-rest-api-client';
import { spaces, content, restActionCreator } from '@confluence-classic/confluence-legacy-redux';

export const getSpaceByKey = restActionCreator('SPACE_INFO', space, {
	schema: spaces,
});

export const markFeatureDiscovered = restActionCreator('FEATURE_DISCOVERED_MARK', markDiscovered);

export const getEditorContentMetadata = restActionCreator(
	'EDITOR_CONTENT_METADATA',
	editPageMetadata,
	{ schema: content },
);
